/* t208/t622/t630: delivery estimate (single day ≈ 8 business days; Owner fastest~8). No range. Mobile sticky ATC, set-link stone prefill. Draft theme only. */
(function () {
  'use strict';
  // ---- estimated delivery (business days, Mon–Fri) — SINGLE day, no range (t622) ----
  function addBusinessDays(d, n) { var x = new Date(d); var added = 0; while (added < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) added++; } return x; }
  function fmt(d) { try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); } }
  document.querySelectorAll('[data-kynd-eta]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-days'), 10);
    if (!days || isNaN(days)) {
      // fallback: lower bound of legacy min/max (prefer data-min)
      days = parseInt(el.getAttribute('data-min'), 10) || 8;
    }
    el.textContent = fmt(addBusinessDays(new Date(), days));
  });

  // ---- prefill birthstones from ?kynd_left=&kynd_right= (used by Complete the set) ----
  var params = new URLSearchParams(location.search);
  function pick(side, val) {
    if (!val) return;
    var inp = document.querySelector('input[type="radio"][name="properties[' + side + ' Birthstone]"][value="' + CSS.escape(val) + '"]');
    if (inp && !inp.checked) inp.click();
  }
  function prefill() { pick('Left', params.get('kynd_left')); setTimeout(function () { pick('Right', params.get('kynd_right')); }, 250); }
  if (params.get('kynd_left') || params.get('kynd_right')) { if (document.readyState === 'complete') prefill(); else window.addEventListener('load', prefill); }

  // keep set link in sync with chosen stones
  var setLink = document.querySelector('[data-kynd-set-link]');
  function syncSet() {
    if (!setLink) return;
    var l = document.querySelector('input[name="properties[Left Birthstone]"]:checked'), r = document.querySelector('input[name="properties[Right Birthstone]"]:checked');
    var u = new URL(setLink.href, location.origin); u.searchParams.delete('kynd_left'); u.searchParams.delete('kynd_right');
    if (l) u.searchParams.set('kynd_left', l.value); if (r) u.searchParams.set('kynd_right', r.value);
    setLink.href = u.pathname + u.search;
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.name && e.target.name.indexOf('Birthstone]') > -1) syncSet(); });
  syncSet();

  // ---- mobile sticky ATC ----
  var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
  var btn = form && form.querySelector('.product-form__submit');
  if (!btn) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var titleEl = document.querySelector('.product__title h1, .product__title');
  var bar = document.createElement('div');
  bar.className = 'kynd-t208-sticky'; bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div class="kynd-t208-sticky__info"><span class="kynd-t208-sticky__title"></span><span class="kynd-t208-sticky__price"></span></div><button type="button" class="kynd-t208-sticky__btn" tabindex="-1">Add to cart</button>';
  document.body.appendChild(bar);
  bar.querySelector('.kynd-t208-sticky__title').textContent = titleEl ? titleEl.textContent.trim() : '';
  function priceText() { var p = document.querySelector('.product__info-container .price__sale:not([hidden]) .price-item--sale, .product__info-container .price-item--regular'); return p ? p.textContent.trim() : ''; }
  function btnInView() { var r = btn.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight && r.height > 0; }
  function update() {
    var show = mq.matches && !btnInView() && !document.querySelector('cart-drawer.active') && !document.querySelector('.kynd-reward.is-open, .kynd-reward[open]');
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('kynd-t208-sticky-on', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) { bar.querySelector('.kynd-t208-sticky__price').textContent = priceText(); bar.querySelector('.kynd-t208-sticky__btn').textContent = btn.disabled ? (btn.textContent.trim() || 'Sold out') : 'Add to cart'; }
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }, { passive: true });
  window.addEventListener('resize', update);
  document.addEventListener('click', function () { setTimeout(update, 400); });
  mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);
  bar.querySelector('.kynd-t208-sticky__btn').addEventListener('click', function () {
    if (btn.disabled) return;
    var missing = null;
    form.ownerDocument.querySelectorAll('input[required][form="' + form.id + '"], ' + '#' + form.id + ' [required]').forEach(function (i) {
      if (missing) return;
      if (i.type === 'radio') { if (!document.querySelector('input[name="' + CSS.escape(i.name) + '"]:checked')) missing = i; }
      else if (!i.value) missing = i;
    });
    if (missing) { var box = missing.closest('fieldset') || missing; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    btn.click();
  });
  update();
})();
